var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLineArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.47812C0.668629 4.47812 0.4 4.74675 0.4 5.07812C0.4 5.4095 0.668629 5.67813 1 5.67813V4.47812ZM17.4243 5.50239C17.6586 5.26807 17.6586 4.88818 17.4243 4.65386L13.6059 0.835484C13.3716 0.60117 12.9917 0.60117 12.7574 0.835484C12.523 1.0698 12.523 1.4497 12.7574 1.68401L16.1515 5.07812L12.7574 8.47224C12.523 8.70655 12.523 9.08645 12.7574 9.32077C12.9917 9.55508 13.3716 9.55508 13.6059 9.32077L17.4243 5.50239ZM1 5.07812V5.67813H17V5.07812V4.47812H1V5.07812Z",
    fill: "#364153"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLineArrow);
export default __webpack_public_path__ + "static/media/ic-line-arrow.30a6ba8798d86f79e5a3801d0a6a4249.svg";
export { ForwardRef as ReactComponent };